export default __webpack_public_path__ + "static/media/Om-Sarva-Mangal-Mangalye.1f716ca9.ogg";